export default "__VITE_ASSET__BQJxHB2$__"